import { inject, observer } from "mobx-react";
import React from "react";
import { L10n } from "@fidget/common/i18n";
import { ICalendarStore } from "../../models/calendar/CalendarStore";
import { InjectedCalendarStore } from "../../models/calendar";
import styles from "./calendarDragOverlay.css";

export interface Props {
  calendarStore?: ICalendarStore;
}

export interface State {
  mouseX: number;
  mouseY: number;
}

@inject("calendarStore")
@observer
export class CalendarDragOverlay extends React.Component<Props, State> {
  mouseX?: number;
  mouseY?: number;

  constructor(props: Props) {
    super(props);
    this.state = { mouseX: 0, mouseY: 0 };
    this.handleMouseMove = this.handleMouseMove.bind(this);
  }

  get injected(): InjectedCalendarStore {
    return this.props as InjectedCalendarStore;
  }

  handleMouseMove(ev: MouseEvent) {
    const { draggingMeeting } = this.injected.calendarStore;
    if (draggingMeeting && !draggingMeeting.calendarPosition) {
      this.setState({ mouseX: ev.clientX, mouseY: ev.clientY });
    } else {
      this.resetStateIfNeeded();
      this.mouseX = ev.clientX;
      this.mouseY = ev.clientY;
    }
  }

  resetStateIfNeeded() {
    if (this.state.mouseX !== 0 || this.state.mouseY !== 0) {
      this.setState({ mouseX: 0, mouseY: 0 });
    }
  }

  componentDidMount() {
    window.addEventListener("mousemove", this.handleMouseMove);
  }

  componentWillUnmount() {
    window.removeEventListener("mousemove", this.handleMouseMove);
  }

  renderElement() {
    const { draggingMeeting } = this.injected.calendarStore;
    const inTrashBar = draggingMeeting && draggingMeeting.inTrashBar;

    if (draggingMeeting && !draggingMeeting.calendarPosition) {
      const mX = this.state.mouseX !== 0 ? this.state.mouseX : this.mouseX;
      const mY = this.state.mouseY !== 0 ? this.state.mouseY : this.mouseY;
      const [offsetX, offsetY] = draggingMeeting.parentOffset;
      const guestName = draggingMeeting.guest && draggingMeeting.guest.displayName;
      return (
        <div
          style={{
            width: `${draggingMeeting.initialWidth}px`,
            left: `${mX ? mX - offsetX : NaN}px`,
            top: `${mY ? mY - offsetY : NaN}px`
          }}
          className={[styles["drag-element"]].concat(inTrashBar ? [styles.invalid] : []).join(" ")}
        >
          <div className={styles["drag-element-header"]}>{guestName}</div>
          <div className={styles["drag-element-body"]}>
            <L10n id={inTrashBar ? "calendar.dropHereToDelete" : "calendar.meeting.dragAndDrop"} />
          </div>
        </div>
      );
    } else {
      return;
    }
  }

  render() {
    return <div className={styles["drag-overlay"]}>{this.renderElement()}</div>;
  }
}
